import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import { useRef } from 'react';

import Sidebar from 'components/Sidebar';

import FormTips from './FormTips';

const TopContributorsOffersRanking = dynamic(
  () => import('components/TopContributorsOffersRanking'),
  { ssr: false }
);

const SuggestNewCouponSidebar = ({
  gaEventCategory,
  isShowingSuccessMessage = false,
  ...rest
}) => {
  const topContributorsOffersRankingRef = useRef(null);
  const suggestNewCouponTips = useRef(null);

  return (
    <Sidebar
      refsToBeIgnoredBeforeFixing={[
        topContributorsOffersRankingRef,
        suggestNewCouponTips,
      ]}
      {...rest}
    >
      {isShowingSuccessMessage ? (
        <TopContributorsOffersRanking
          ref={topContributorsOffersRankingRef}
          gaEventCategory={gaEventCategory}
        />
      ) : (
        <FormTips ref={suggestNewCouponTips} />
      )}
    </Sidebar>
  );
};

SuggestNewCouponSidebar.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
  isShowingSuccessMessage: PropTypes.bool,
};

export default SuggestNewCouponSidebar;
